<i18n src="../translations"></i18n>

<template>
  <div>
    <div
      class="info-link qa-ProductCard__showOeNumbers"
      role="button"
      tabindex="0"
      :aria-label="$t('product-info-sections.oe-numbers')"
      @click="show()"
      @keydown.enter.prevent="show()"
      @keydown.space.prevent="show()"
    >
      {{ label || $t('product-info-sections.parts-dialog-trigger')
      }}<ArrowOpenModalSvg v-if="!hideIcon" class="info-arrow" />
    </div>

    <Dialog
      ref="oeNumbersDialog"
      class="pdp-info-dialog"
      :click-outside="true"
      :title="$t('product-info-sections.oe-numbers')"
      :use-frame-padding="false"
    >
      <Table
        :is-ajax="!oeNumbers.length"
        :url="!oeNumbers.length ? ajaxUrl : undefined"
        :entities="oeNumbers.length ? oeNumbers : undefined"
        :columns="oeNumbers.length ? columns : undefined"
        :load-more="!oeNumbers.length"
        :load-more-label="$t('product-info-sections.more-oe-numbers')"
        :initial-rows-limit="4"
        table-key="oeNumbers"
        :has-border="false"
        @tableIsEmpty="$emit('empty', 'oeNumbers')"
      >
        <template #oeNumber="{ entity }">
          <MaskedLink
            :text="entity.oeNumber"
            :redirect-to="oeSearchUrl(entity.oeNumber)"
            class="info-link"
          />
        </template>
      </Table>
    </Dialog>
  </div>
</template>

<script>
import ArrowOpenModalSvg from 'Components/00-generated/ArrowOpenModalSvg';
import Dialog from 'Components/02-molecules/dialog/Dialog';
import Table from 'Components/01-atoms/table/Table';
import MaskedLink from 'Components/01-atoms/masked-link/MaskedLink';
import globalMixin from 'Libs/mixins/globalMixin';

const BASE_COLUMNS = [
  {
    key: 'manufacturer',
    i18nKey: 'product-info-sections.oe-numbers-table.manufacturer',
  },
  {
    key: 'oeNumber',
    i18nKey: 'product-info-sections.oe-numbers-table.oeNumber',
  },
];

export default {
  name: 'PdpInfoOeLink',
  components: { ArrowOpenModalSvg, Dialog, Table, MaskedLink },
  mixins: [globalMixin],
  props: {
    oeNumbers: { type: Array, default: () => [] },
    productId: { type: String, required: true },
    label: { type: String, default: '' },
    hideIcon: { type: Boolean, default: false },
  },
  computed: {
    columns() {
      return BASE_COLUMNS.map((c) => ({
        key: c.key,
        label: this.$t(c.i18nKey),
      }));
    },
    ajaxUrl() {
      return this.frontFacingPath('search.ajax.product.oe_numbers')?.replace(
        '{productId}',
        this.productId
      );
    },
  },
  methods: {
    show() {
      this.$refs.oeNumbersDialog.show();
    },
    oeSearchUrl(oeNumber) {
      const params = new URLSearchParams({ search: oeNumber.trim() });

      return `${this.frontFacingPath(
        'search.search_bar.search'
      )}?${params.toString()}#oens`;
    },
  },
};
</script>

<style scoped lang="scss">
@import './_linkBase.scss';

.info-link {
  @media #{$_mediaLDown} {
    margin-bottom: var(--space-1);
  }
}
</style>
